export const validators = {
    required: (el) => {
        if (el.hasAttribute("required") && !el.value.trim()) {
            return "required";
        }
        return true;
    },

    email: (el) => {
        if (el.type === "email" && el.value.trim()) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!regex.test(el.value)) return "email";
        }
        return true;
    },

    minlength: (el) => {
        const min = el.getAttribute("minlength");
        if(!el.value || el.value.length === 0) return true;

        if (min && el.value.length < parseInt(min, 10)) {
            return "minlength";
        }
        return true;
    },

    maxlength: (el) => {
        const max = el.getAttribute("maxlength");
        if (max && el.value.length > parseInt(max, 10)) {
            return "maxlength";
        }
        return true;
    },

    pattern: (el) => {
        const pattern = el.getAttribute("pattern");
        if (pattern && el.value.trim()) {
            const regex = new RegExp(pattern);
            if (!regex.test(el.value)) return "pattern";
        }
        return true;
    },

    number: (el) => {
        if (el.type === "number" && el.value.trim()) {
            const value = parseFloat(el.value);
            if (isNaN(value)) return "number";

            const min = el.getAttribute("min");
            const max = el.getAttribute("max");

            if (min !== null && value < parseFloat(min)) return "min";
            if (max !== null && value > parseFloat(max)) return "max";
        }
        return true;
    },

    date: (el) => {
        if (el.type !== "date") return true;

        const raw = el.value && el.value.trim();
        if (!raw) return true; // la règle "required" s'en charge ailleurs
        console.debug("raw date", raw);
        const toUTCms = (s) => {
            const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
            if (!m) return NaN;
            const y = +m[1], mo = +m[2], d = +m[3];
            //const t = Date.UTC(y, mo - 1, d);
            // Validation stricte (évite 2025-02-31 qui "roule" en mars)
            const dt = new Date(y, mo, d);
            return dt;
            /*return (dt.getUTCFullYear() === y &&
                dt.getUTCMonth() === mo - 1 &&
                dt.getUTCDate() === d) ? t : NaN;*/
        };

        const valueMs =  new Date(raw)//toUTCms(raw);
        if (Number.isNaN(valueMs)) return "date";

        const minAttr = el.getAttribute("min");
        if (minAttr) {
            const minMs = toUTCms(minAttr);
            if (!Number.isNaN(minMs) && valueMs < minMs) return "minDate";
        }

        const maxAttr = el.getAttribute("max");
        if (maxAttr) {
            const maxMs = toUTCms(maxAttr);
            if (!Number.isNaN(maxMs) && valueMs > maxMs) return "maxDate";
        }

        return true;
    },

};

export function validateLinkedinUrl(el) {

    console.log(el);
    let url = el.value;
    if (!url || url === ''){
        return true;
    }
    const regex = /^https:\/\/(www\.)?linkedin\.com\/(in|pub|profile)\/[a-zA-Z0-9_%-]+\/?([?#].*)?$/;

    url = url.trim();

    if (regex.test(url)) {
        return true;
    } else {
        return 'urlLinkedIn';
    }
}

/**
 *
 * @returns {boolean}
 * @param el
 */
export function validateTvaID(el){
    let vat = el.value;
    if (!vat || vat === ''){return true}
    vat = vat.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (vat.length < 4) return  'not_tva_intra';

    const country = vat.slice(0, 2);
    const number = vat.slice(2);

    const patterns = {
        AT: /^U\d{8}$/,
        BE: /^0?\d{9}$/,
        BG: /^\d{9,10}$/,
        CY: /^\d{8}[A-Z]$/,
        CZ: /^\d{8,10}$/,
        DE: /^\d{9}$/,
        DK: /^\d{8}$/,
        EE: /^\d{9}$/,
        EL: /^\d{9}$/,
        ES: /^[A-Z0-9]\d{7}[A-Z0-9]$/,
        FI: /^\d{8}$/,
        FR: /^[A-Z0-9]{2}\d{9}$/,
        HR: /^\d{11}$/,
        HU: /^\d{8}$/,
        IE: /^\d{7}[A-Z]{1,2}$/,
        IT: /^\d{11}$/,
        LT: /^(\d{9}|\d{12})$/,
        LU: /^\d{8}$/,
        LV: /^\d{11}$/,
        MT: /^\d{8}$/,
        NL: /^\d{9}B\d{2}$/,
        PL: /^\d{10}$/,
        PT: /^\d{9}$/,
        RO: /^\d{2,10}$/,
        SE: /^\d{12}$/,
        SI: /^\d{8}$/,
        SK: /^\d{10}$/
    };

    if (!patterns[country]) return true; // TVA non UE
    if (!patterns[country].test(number)) return  'invalid';

    // Vérification France
    if (country === 'FR') {
        const key = number.slice(0, 2);
        const siren = number.slice(2);

        if (!/^\d{9}$/.test(siren)) return  'control_failed_FR';

        const calcKey = (12 + 3 * (Number(siren) % 97)) % 97;
        const calcKeyStr = calcKey.toString().padStart(2, '0');

        // Si la clé est numérique, on vérifie la correspondance
        if (/^\d+$/.test(key) && key !== calcKeyStr) {
            return 'control_failed_FR';
        }
    }

    return true;
}
